import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/research", label: "Research" },
    { to: "/incubation", label: "Incubation" },
    { to: "/models", label: "AI Models" },
  ];

  return (
    <nav className="bg-surface shadow-sm sticky top-0 z-50">
      <div className="flex justify-between items-center w-full px-gutter max-w-container-max mx-auto h-16">
        <Link to="/" className="flex items-center gap-2">
          <img src="/cafe-logo.webp" alt="CAFE" className="h-10 w-10 object-contain" />
        </Link>
        <div className="hidden md:flex gap-8 items-center">
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`font-headline-md text-headline-md transition-colors ${
                pathname === link.to
                  ? "text-primary border-b-2 border-primary pb-1"
                  : "text-on-surface-variant hover:text-primary"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-4">
          <button
            className="material-symbols-outlined md:hidden text-on-surface-variant hover:text-primary transition-colors"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? "close" : "menu"}
          </button>
          <button className="material-symbols-outlined hidden md:block text-on-surface-variant hover:text-primary transition-colors">science</button>
          <button className="material-symbols-outlined hidden md:block text-on-surface-variant hover:text-primary transition-colors">notifications</button>
        </div>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-surface border-t border-outline-variant px-gutter py-4 space-y-3">
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className={`block py-2 font-headline-md text-headline-md transition-colors ${
                pathname === link.to
                  ? "text-primary font-bold"
                  : "text-on-surface-variant"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
